import {HttpClient, HttpHeaders, HttpParams, HttpResponse} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Carteira} from "../carteira/carteira.model";
import {GrupoCarteira} from "../grupo-carteira/grupo-carteira";
import {
  AssociacaoModel,
  CarteiraSelecaoModel,
  GrupoCarteiraSelecaoModel
} from "./associacao-grupo-carteira-stepper/associacao-model";
import {Observable} from "rxjs";
import {catchError} from "rxjs/operators";
import {handleError} from "../shared/util/error-util";

@Injectable({
  providedIn: "root",
})
export class AssociacaoGrupoCarteiraService {
  private readonly url = "/v1/grupo-carteiras";
  paginationTotalPage = 1;

  private readonly carteiras: CarteiraSelecaoModel[];
  private readonly gruposCarteiras: GrupoCarteiraSelecaoModel[];

  private readonly contentType = "application/json";
  private readonly headers = new HttpHeaders({"Content-Type": this.contentType});

  constructor(private readonly http: HttpClient) {
    this.gruposCarteiras = [];
    this.carteiras = [];
  }

  addCarteira(value: Carteira, carteiras: Carteira[]) {
    if (!value || (value.name !== null && carteiras.includes(value))) {
      return false;
    }

    carteiras.push(value);
    carteiras.sort(this.compareNome);
    return true;
  }

  addGrupoCarteira(value: GrupoCarteira, gruposCarteiras: GrupoCarteira[]) {
    if (!value || (value.nome !== null && gruposCarteiras.includes(value))) {
      return false;
    }

    gruposCarteiras.push(value);
    gruposCarteiras.sort(this.compareNome);
    return true;
  }

  compareNome(a: any, b: any) {
    if (a.nome < b.nome) {
      return -1;
    }
    if (a.nome > b.nome) {
      return 1;
    }
    return 0;
  }

  removerCarteira(carteira: any, carteiras: Carteira[]) {
    const index = carteiras.findIndex(c => c.id === carteira.id);
    if (index >= 0) {
      this.removerAssociacaoParaCarteira(carteira);
      return carteiras.splice(index, 1);
    }
    return carteiras;
  }

  private removerAssociacaoParaCarteira(carteiraSelecionada: CarteiraSelecaoModel) {
    // while (this.aindaContemCarteira(s)) {
    //   const index = this.validacaoSelecaoModels.findIndex(
    //     (i) => i.carteiraNome === s.nome
    //   );
    //   if (index >= 0) {
    //     this.validacaoSelecaoModels.splice(index, 1);
    //   }
    // }
  }

  removerGrupoCarteira(grupoCarteira: any, gruposCarteiras: GrupoCarteira[]) {
    const index = gruposCarteiras.findIndex(gp => gp.id === grupoCarteira.id);
    if (index >= 0) {
      this.removerAssociacaoParaGrupoCarteira(grupoCarteira);
      return gruposCarteiras.splice(index, 1);
    }
    return gruposCarteiras;
  }

  private removerAssociacaoParaGrupoCarteira(grupoCarteiraSelecionada: CarteiraSelecaoModel) {
    // while (this.aindaContemCarteira(s)) {
    //   const index = this.validacaoSelecaoModels.findIndex(
    //     (i) => i.carteiraNome === s.nome
    //   );
    //   if (index >= 0) {
    //     this.validacaoSelecaoModels.splice(index, 1);
    //   }
    // }
  }

  // getAssociacao() {
  //   if (this.validacaoSelecaoModels.length === 0) {
  //     this.calcularSelecaoModel();
  //   }
  //   return this.validacaoSelecaoModels;
  // }

  associar(grupo: GrupoCarteira, carteiras: Carteira[]) {
    const headers = this.headers;
    const associacao: AssociacaoModel = new AssociacaoModel();
    associacao.carteirasIds = carteiras.map(c => c.id);
    associacao.grupoCarteiraNome = grupo.nome;
    return this.http.post<any>(`${this.url}/associacoes/create`, associacao, {headers}).pipe();
  }

  excluirAssociacao(grupo: GrupoCarteira, carteiras: Carteira[]): Observable<any> {
    const headers = this.headers;
    const associacao: AssociacaoModel = new AssociacaoModel();
    associacao.carteirasIds = carteiras.map(c => c.id);
    associacao.grupoCarteiraNome = grupo.nome;

    return this.http.post<any>(`${this.url}/associacoes/remove`, associacao, {headers}).pipe();
  }

  downloadModelo(): Observable<HttpResponse<Blob>> {
    return this.getExportDataFrom(`${this.url}/download-modelo/associacao`);
  }

  private getExportDataFrom(path: string): Observable<HttpResponse<Blob>> {
    const params = new HttpParams();
    return this.http.get(path, {
      responseType: "blob",
      observe: "response",
      params
    }).pipe(catchError(handleError));
  }
}
